import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { MarqueeBanner } from '../components/MarqueeBanner';
import { HeroSection } from '../components/HeroSection';
import { FormulaSection } from '../components/FormulaSection';
import { LogrosSection } from '../components/LogrosSection';
import { ModeloNegocioSection } from '../components/ModeloNegocioSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { AlumnosSection } from '../components/AlumnosSection';
import { CourseContentSection } from '../components/CourseContentSection';
import { TestimonialsBanner } from '../components/TestimonialsBanner';
import { TestimonialsFeatures } from '../components/TestimonialsFeatures';
import { BonusSection } from '../components/BonusSection';
import { FAQ2Section } from '../components/FAQ2Section';
import { TestimonialsMasonrySection } from '../components/TestimonialsMasonrySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  useEffect(() => {
    document.title = 'Emprende Digital';
    // Update meta tags for link sharing
    const setMeta = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        if (property.startsWith('og:')) {
          tag.setAttribute('property', property);
        } else {
          tag.setAttribute('name', property);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('description', 'Emprende Digital - Generá ingresos extra vendiendo por internet desde cero');
    setMeta('og:title', 'Emprende Digital');
    setMeta('og:description', 'Generá ingresos extra vendiendo por internet desde cero');
    setMeta('og:type', 'website');
  }, []);
  return <main className="w-full min-h-screen bg-brand-bg overflow-x-hidden" data-id="element-507">
      <MarqueeBanner data-id="element-508" />
      <UrgencyBanner data-id="element-509" />
      <HeroSection data-id="element-510" />

      <CaseStudySection data-id="element-511" />
      <AlumnosSection data-id="element-512" />
      <TestimonialsBanner data-id="element-513" />
      <TestimonialsFeatures data-id="element-514" />
      <LogrosSection data-id="element-515" />
      <CourseContentSection data-id="element-516" />
      <ModeloNegocioSection data-id="element-517" />
      <BonusSection data-id="element-518" />
      <PricingSection data-id="element-519" />
      <motion.div className="w-full bg-brand-bg py-10 text-center" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-520">
        <a href="#pricing" onClick={e => {
        e.preventDefault();
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-lg px-10 py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 cursor-pointer" data-id="element-521">
          🔥 Empezar Ahora
        </a>
      </motion.div>
      <TestimonialsSection data-id="element-522" />
      <TestimonialsMasonrySection data-id="element-523" />
      <FAQ2Section data-id="element-524" />
      <FinalCTASection data-id="element-525" />
    </main>;
}